"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.UtilityLinks = exports.LinkList = exports.NavContainer = exports.Wrapper = exports.utilityNavHeight = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Layout = require("../../Layout");

var _Link = _interopRequireDefault(require("../../Link"));

var utilityNavHeight = '8rem';
exports.utilityNavHeight = utilityNavHeight;
var Wrapper = (0, _styled.default)('div')(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      globalNav = _ref$theme.globalNav;
  return {
    backgroundColor: globalNav.utilityNavBg,
    color: colors.white
  };
});
exports.Wrapper = Wrapper;
var NavContainer = (0, _styled.default)(_Layout.Container)(function (_ref2) {
  var hasUtilityLinks = _ref2.hasUtilityLinks;
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: hasUtilityLinks ? 'space-between' : 'flex-end',
    height: utilityNavHeight
  };
});
exports.NavContainer = NavContainer;
var LinkList = (0, _styled.default)('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '1 0 auto'
});
exports.LinkList = LinkList;
var UtilityLinks = (0, _styled.default)(_Link.default)(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      space = _ref3$theme.space,
      mediaQueries = _ref3$theme.mediaQueries;
  return {
    marginRight: space.large,
    span: _defineProperty({
      fontWeight: 'normal',
      fontSize: '1.2rem',
      lineHeight: '1.3rem'
    }, mediaQueries.small, {
      fontSize: '1.8rem',
      lineHeight: '1.9rem'
    })
  };
});
exports.UtilityLinks = UtilityLinks;